import React from 'react';
import { observer } from "mobx-react";
import { TitanJackpotAmountBox } from './boxes/titan-jackpot-amount-container.box'
import { useServices } from '../../react-hooks/use-services.hook';

export const TitanJackpotAmountComponent: React.FC = observer(() => {
    const services = useServices();

    return (
        <TitanJackpotAmountBox>
            {services.currency.formatMoney(services.titanJackpot.jackpotHandler?.jackpotAmount)}
        </TitanJackpotAmountBox>
    )
});